import React from "react";

function SkillDetails(){
    return (
        <div>Skill Detail</div>
    )

}

export default SkillDetails;